<div>
  <mat-sidenav-container autosize="true">
    <mat-sidenav #mainNav class="main-nav" mode="side" opened="true" disableClose="true" *ngIf="!headerService.isMobileAppView">
      <app-main-nav (sidenavToggle)="secondNav?.toggle()"></app-main-nav>
    </mat-sidenav>

    <mat-sidenav-content>
      <mat-sidenav-container autosize="true">
        <mat-sidenav #secondNav class="secondary-nav" [mode]="sidenavMode" opened="true" *ngIf="!headerService.isMobileAppView">
          <app-new-side-menu (sidenavClose)="secondNav.close()" (sidenavOpen)="secondNav.open()"></app-new-side-menu>
        </mat-sidenav>
        <mat-sidenav-content>
          <!--<app-new-side-menu></app-new-side-menu>-->
          <app-new-header *ngIf="!headerService.isMobileAppView"></app-new-header>
          <div>
            <div class="wrapper" [ngClass]="{'hidden':!headerService.showMenu, 'is-mobile-view': isMobileView}" [style.height]="wrapperHeight">
              <div class="col-auto-main">
                <div fxFill fxLayout="column" fxLayoutAlign="start stretch">
                  <app-global-notifications></app-global-notifications>
                  <div fxFlex>
                    <router-outlet #routerOutlet="outlet"></router-outlet>
                  </div>
                </div>
              </div>
            </div>
            <footer class="page__footer" *ngIf="!headerService.isMobileAppView">
              <div class="row">
                <div class="col-xs-12 page__footer__holder">
                  <span class="page__footer__year">{{currentYear}}</span> © TeleGo Inc. ® All rights reserved.
                  <a href="https://kb.telego.com/article/110-privacy-policy" target="_blank">Privacy</a> and
                  <a href="https://kb.telego.com/article/111-telego-terms-and-conditions" target="_blank">Terms</a>
                </div>
              </div>
            </footer>
          </div>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
